export default function pickKeys(obj = {}, keys = []) {
  return Object
    .keys(obj)
    .reduce(
      (acc, keyName) => {
        if (keys.includes(keyName)) {
          acc[keyName] = obj[keyName];
        }

        return acc;
      },
      {},
    );
}
